<template>
  <div class="modal-iframe">
    <v-modal
      :maxWidth="maxWidth"
      :showFooterCloseButton="false"
      @close="closeModal()"
      class="modal"
    >
      <div slot="body">
        <iframe
          id="introVideo"
          :width="width"
          :height="height"
          :src="src"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
    </v-modal>
  </div>
</template>

<script>
export default {
  name: 'modal-iframe',
  props: {
    src: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    maxWidth: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: '450px'
    }
  },
  methods: {
    closeModal(e) {
      this.$emit('closePopup', true)
    }
  }
}
</script>
